import { createUseStyles } from 'react-jss'
import classNames from 'classnames'
import styles  from './styles.module.scss'
import { useEffect, useState } from 'react'

const importAll = require => 
  require.keys().reduce((acc, next) => {
    acc[next.replace('./', '')] = require(next)
    return acc
  }, {})
const images = importAll(require.context('./svg', false, /\.(png|jpe?g|svg)$/))
console.log('images', images)

const useStyles = createUseStyles({
  icon: {
    display: 'inline-block',
    minWidth: (props) => props.width??props.size??'1.2rem',
    minHeight: (props) => props.height??props.size??'1.2rem',
    '-webkit-mask-image' : (props) => `url(${images[props.iconName]?.default})`,
    '-webkit-mask-size': (props) => `${props.width??props.size??'1.2rem'} ${props.height??props.size??'1.2rem'}`,
    '-webkit-mask-repeat': 'no-repeat ',
    '-webkit-mask-position': 'center left',
    backgroundColor: (props) => props.bg??props.colorPrimaryGrey,

    '&:hover': {
      backgroundColor: (props) => {
        return props.hoverBg??props.bg??props.colorPrimaryGrey
      }
    }
  }

})

export const Icon = ({name, bg, hoverBg, width, height, size, className, disabled, ...props}) => {
  
  //const [iconName, setIconName] = useState
  const colorPrimaryGrey =   '#929A9D'
  const iconName = `icon-${name??'button-close'}.svg`
  props.iconName = iconName
  props.colorPrimaryGrey = colorPrimaryGrey
  props.bg = bg
  props.hoverBg = hoverBg
  props.width = width
  props.size = size
  props.disabled = disabled
  const classes = useStyles(props)

  // useEffect(()=> {
  //   //setIconName(`icon-${name??'button-close'}.svg`)
  //   //console.log('iconName', name, iconName, classes.icon)
  // }, [name])
  
  
  return <i className={classNames(classes.icon, className, {[styles.iconDisabled]: disabled})}></i>
}

